<template>
    <div class="a-channels">
      <Toggle class="a-channels__button"
              v-on:click.native="goToChannel(previousChannel)"
              :previous="previousChannelOf(previousChannel).name"
              :current="previousChannel.name"
              :next="currentChannel.name"></Toggle>
      <Toggle class="a-channels__button --active"
              :previous="previousChannel.name"
              :current="currentChannel.name"
              :next="nextChannel.name"></Toggle>
      <Toggle class="a-channels__button"
              v-on:click.native="goToChannel(nextChannel)"
              :previous="currentChannel.name"
              :current="nextChannel.name"
              :next="nextChannelOf(nextChannel).name"></Toggle>
      <!--
        <div class="a-channels__button"
                v-bind:class="{ '-active': channel === currentChannel }"
                v-for="channel in channels"
                v-on:click="goToChannel(channel)"
                v-bind:key="channel.name">
            <span v-once>{{ channel.name }}</span>
            <span class="a-channels__edit"
                  v-on:click="editChannel(channel)"
                  v-if="channel.editable === true">o</span>
        </div>
        <button v-on:click="openForm">
            créer
        </button>
        <div class="popinForm" :class="{ 'open': isOpenNew }">
            <form @submit="checkForm" method="post">
                <h4>Création d'une chaine</h4>
                <input type="text" placeholder="nom de la chaine" name="name" v-model="name">
                <br>
                <input type="text" placeholder="mot clé" name="slugs" v-model="slugs">
                <br>
                <button type="submit">créer la chaine</button>
            </form>
        </div>
        <div class="popinChannEdit" :class="{ 'open': isOpenEdit }">
            <form @submit="checkFormEdit" method="post">
                <h4>éditer ma chaine</h4>
                <input type="text"
                       placeholder="nom de la chaine" name="nameEdit" v-model="nameEdit">
                <br>
                <input type="text"
                       placeholder="mot clé" name="slugsEdit" v-model="slugsEdit">
                <br>
                <button type="submit">éditer</button>
            </form>
            <form @submit="checkFormSupp" method="post">
                <h4>supprimer la chaine</h4>
                <button type="submit">supprimer</button>
            </form>
        </div>-->
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Toggle from './Channels/Toggle';

export default {
  name: 'channels',
  components: {
    Toggle,
  },
  data() {
    return {
      isOpenNew: false,
      isOpenEdit: false,
      name: null,
      slugs: [],
      nameEdit: null,
      slugsEdit: [],
      channelEdit: '',
    };
  },
  computed: {
    ...mapGetters([
      'channels',
      'currentChannel',
      'nextChannel',
      'previousChannel',
    ]),
  },
  methods: {
    ...mapActions([
      'addChannel',
      'removeChannel',
      'getChannelById',
    ]),
    ...mapMutations([
      'setChannelName',
    ]),
    goToChannel(nextChannel) {
      this.$router.push(`/c/${nextChannel.id}`);
    },
    nextChannelOf(channel) {
      const index = this.channels.indexOf(channel);
      return this.channels[index < this.channels.length - 1 ? index + 1 : 0];
    },
    previousChannelOf(channel) {
      const index = this.channels.indexOf(channel);
      return this.channels[index > 0 ? index - 1 : this.channels.length - 1];
    },
    openForm() {
      this.isOpenNew = true;
    },
    closeForm() {
      this.isOpenNew = false;
    },
    checkForm(e) {
      e.preventDefault();
      this.getChannelById(this.name).then((result) => {
        this.addChannel(result);
        this.closeForm();
      });
    },
    checkFormEdit(e) {
      e.preventDefault();
      this.setChannelName({ channel: this.channelEdit, name: this.nameEdit });
      this.channelEdit = '';
      this.isOpenEdit = false;
    },
    checkFormSupp(e) {
      e.preventDefault();
      this.removeChannel(this.channelEdit);
      this.channelEdit = '';
      this.isOpenEdit = false;
    },
    editChannel(channel) {
      this.isOpenEdit = true;
      this.nameEdit = channel.name;
      this.channelEdit = channel;
    },
  },
};
</script>

<style scoped lang="scss">
    .a-channels {
      &__button {
        display: block;

        border: 0;
        outline: 0;

        color: gray;

        font-family: TrioGrotesk, sans-serif;
        text-align: center;
        text-transform: uppercase;
        font-size: 14px;
        line-height: 14px;

        background: transparent;

        &.--active {
          color: black;
          border-top: 1px solid black;
          border-bottom: 1px solid black;
          font-size: 18px;
          line-height: 18px;
        }
      }
      &__edit {
          background-color: rgba(0, 0, 0, 0.45);
          position: relative;
          z-index: 10;
      }
    }
    .popinForm {
      position: fixed;
      z-index: 3;
      background-color: #fff;
      padding: 40px 100px;
      width: 70vw;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-family: Helvetica;
      display: none;
      line-height: 22px;
      max-width: 800px;
      max-height: 80vh;
      overflow-y: scroll;

      &.open {
          display: block;
      }
    }
    .popinChannEdit {
      position: fixed;
      z-index: 3;
      background-color: #fff;
      padding: 40px 100px;
      width: 70vw;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-family: Helvetica;
      display: none;
      line-height: 22px;
      max-width: 800px;
      max-height: 80vh;
      overflow-y: scroll;

      &.open {
          display: block;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Player/Channels.vue